import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { MyAccountContainerProps } from "../../../interfaces/containers";
import MyAccount from "../../../pages/Profile/MyAccount/MyAccount";
import { cleanProfileFetching, getConcessionary } from "../../../actions/profile";
import { editUserRequest, postUserImage, cleanPostImage, deleteUser, logoutUser, reSendValidation, cleanReSendValidation } from "../../../actions/auth";

function mapStateToProps(state: MyAccountContainerProps) {
    return {
        user: state.auth.user,
        token: state.auth.token,
        concessionary: state.auth.concessionary,
        editUserReducer: state.auth.fetchingEdit,
        postImage: state.auth.postImage,
        deleteFetching: state.auth.deleteFetching,
        reSendValidationFetching: state.auth.reSendValidationFetching
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getConcessionary,
        editUserRequest,
        cleanProfileFetching,
        postUserImage,
        cleanPostImage,
        deleteUser,
        logoutUser,
        reSendValidation,
        cleanReSendValidation
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);